module.exports = __webpack_public_path__ + "static/media/compass-frame.e047f272.png";